'use strict';
namespace Attractions {
    class AttractionsHeaderPanel {

        teaserPrice: number;
        debouncedUpdateTeaserPrice: Function;

        // Attributes
        product: any = this.product();
        productId: string;
        chooseAgainUrl: string;
        title: string;


        constructor (
            private $location: ng.ILocationService,
            private $scope: ng.IScope,
            private productService,
            private broker
        ) {
            this.debouncedUpdateTeaserPrice = _.debounce(p => this.updateTeaserPrice(p), 100);

            if (!this.chooseAgainUrl) {
                this.chooseAgainUrl = 'attractions';
            }

            let qsTags = $location.search();
            if (qsTags) {
                angular.extend(this.product, {Tags: qsTags});
            }

            broker.subscribe(
                'attractionsHeaderPanel',
                'attractionsProductUpdate',
                res => this.debouncedUpdateTeaserPrice({Tags: res.data})
            );

            $scope.$on('$destroy', () => {
                broker.unsubscribe('attractionsHeaderPanel');
            });
        }

        updateTeaserPrice (productData?): void {
            if (this.product) {
                const date = _.get(productData, 'Tags.date', null);
                let product = angular.extend(
                        {
                            DomainId: TRPCONFIG.Domain.DomainId,
                            Currency: TRPCONFIG.Domain.CurrencyCode
                        },
                        this.product,
                        date === null ? { Tags : _.omit(productData.Tags,('date')) } : productData
                    );

                this.productService.getTeaserPrices('attraction', [product])
                    .then(res => {
                        const resKey = Object.keys(res)[0];
                        if(resKey) {
                            const first = res[resKey];
                            const adultPrice = _.find(first.Prices, {Type: 'Adult'});
                            const price:any = adultPrice || (Array.isArray(first.Prices) && first.Prices.length
                                        ? first.Prices[0] : null);
                            this.teaserPrice = price && price.Price;
                        }
                    });
            }
        }
    }

    angular
        .module('attractions')
        .directive('attractionsHeaderPanel', (): ng.IDirective => {
            return {
                restrict: 'E',
                transclude: true,
                replace: true,
                scope: {},
                bindToController: {
                    product: '&',
                    productId: '@',
                    chooseAgainUrl: '@',
                    panelTitle: '@'
                },
                controller: AttractionsHeaderPanel,
                controllerAs: 'hp',
                templateUrl: 'partials/attractions/headerpanel'
            };
        });
}
